import { PartecipanteItem } from "@/models/ricercaGaranzie/partecipanteItem";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import { Component } from "vue-property-decorator";
import gridComponentBase from "../components/grid/gridComponentBase.vue";
import { Filter } from "@/models/grid/filter";
import { getTuoiAcquistiColumns } from "@/columns/tuoiAcquistiColumns";

const _ENDPONT = api.endpoint.MY_OVERINS.ELENCO_ESTRATTI_CONTO_MIEI;
const _ENDPONT_EXPORT_EXCEL = api.endpoint.MY_OVERINS.ESTRATTI_CONTO_EXPORT_EXCEL;
@Component
export default class TuoiEstrattiContoPage extends gridComponentBase {
	distributori: TextValueItem[] = [];

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "Num EC", width: 80, type: "numeric-int", filterType: "numeric-int", headerCell: "myHeaderCellTemplate", editHide: true, export: true },

			{ field: "anno", title: "Anno",  format: "{0:0}", headerCell: "myHeaderCellTemplate", type: "numeric-int", filterType: "numeric-int", filterable: true, export: true, width: 90, editHide: true },
			{ field: "mese", title: "Mese",  format: "{0:0}", headerCell: "myHeaderCellTemplate", type: "numeric-int", filterType: "numeric-int", filterable: true, export: true, width: 90, editHide: true },
			{
				field: "distributore",
				title: "Ragione Sociale",
				// values: this.distributori,
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				sortBy: "distributore",
				// itemsForFilter: this.distributori,
				// filterType: "select"
			},
			{
				field: "distributore",
				title: "Ragione Sociale",
				hidden: true,
				export: true
			},
			{
				field: "numeroPratiche",
				title: "Pratiche",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric-int",
				filterType: "numeric-int",
				format: "{0:n0}",
				editHide: true,
				export: true
			},
			{
				field: "daPagare",
				title: "Da Pagare",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "totalePagato",
				title: "Pagato",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "totaleSconto",
				title: "Sconto Ad.",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "scontoEC",
				title: "Sconto EC",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				export: true
			},
			{
				field: "saldo",
				title: "Saldo",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "dataEC",
				title: "Creazione",
				width: 120,
				format: "{0:dd/MM/yyyy}",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				export: true,
				type: "date",
				headerType: "daterange",
				editHide: true
			},
			{
				field: "dataInvio",
				title: "Invio",
				width: 120,
				format: "{0:dd/MM/yyyy}",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				export: true,
				type: "date",
				headerType: "daterange",
				editHide: true
			},
			{
				field: "dataSollecito",
				title: "Sollecito",
				width: 120,
				format: "{0:dd/MM/yyyy}",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				export: true,
				type: "date",
				headerType: "daterange",
				editHide: true
			},
			{
				field: "itemID",
				title: "EC Pdf",
				width: 50,
				type: "renderfunction",
				sortable:false,
				groupable: false,
				renderFunction: this.renderCellEstrattoContoRep,
				editHide: true
				// template: function(dataItem) {
				// 	return "<a href='/CMSPages/Webins/WI_EC.aspx?idEC=" + dataItem.ItemID + "' target='_blank'>Apri</a>";
				// }
			},

			{
				field: "itemID",
				title: "EC Excel",
				sortable:false,
				groupable: false,
				width: 50,
				//type: "renderfunction",
				//renderFunction: this.renderCellExportExcel,
				cell: "exportExcelCustomCellTemplate",
				editHide: true
			}
		];
	}

	get columnsMobile(): Array<any> {
		return [
			{ field: "itemID", title: "Num EC", width: 80, type: "numeric-int", filterType: "numeric-int", headerCell: "myHeaderCellTemplate", editHide: true, export: true },

			{ field: "anno", title: "Anno", headerCell: "myHeaderCellTemplate",  format: "{0:0}", type: "numeric-int", filterType: "numeric-int", filterable: true, export: true, width: 90, editHide: true },
			{ field: "mese", title: "Mese", headerCell: "myHeaderCellTemplate",  format: "{0:0}", type: "numeric-int", filterType: "numeric-int", filterable: true, export: true, width: 90, editHide: true },
			{
				field: "distributore",
				title: "Ragione Sociale",
				// values: this.distributori,
				width: 200,
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				sortBy: "distributore",
				// itemsForFilter: this.distributori,
				// filterType: "select"
			},
			{
				field: "distributore",
				title: "Ragione Sociale",
				hidden: true,
				export: true
			},
			{
				field: "numeroPratiche",
				title: "Pratiche",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric-int",
				filterType: "numeric-int",
				format: "{0:n0}",
				editHide: true,
				export: true
			},
			{
				field: "daPagare",
				title: "Da Pagare",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "totalePagato",
				title: "Pagato",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "totaleSconto",
				title: "Sconto Ad.",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "scontoEC",
				title: "Sconto EC",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				export: true
			},
			{
				field: "saldo",
				title: "Saldo",
				width: 100,
				headerCell: "myHeaderCellTemplate",
				type: "numeric",
				filterType: "numeric",
				format: "{0:n2}",
				editHide: true,
				export: true
			},
			{
				field: "dataEC",
				title: "Creazione",
				width: 120,
				format: "{0:dd/MM/yyyy}",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				export: true,
				type: "date",
				headerType: "daterange",
				editHide: true
			},
			{
				field: "dataInvio",
				title: "Invio",
				width: 120,
				format: "{0:dd/MM/yyyy}",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				export: true,
				type: "date",
				headerType: "daterange",
				editHide: true
			},
			{
				field: "dataSollecito",
				title: "Sollecito",
				width: 120,
				format: "{0:dd/MM/yyyy}",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				filterable: true,
				export: true,
				type: "date",
				headerType: "daterange",
				editHide: true
			},
			{
				field: "itemID",
				title: "EC Pdf",
				width: 50,
				type: "renderfunction",
				sortable:false,
				groupable: false,
				renderFunction: this.renderCellEstrattoContoRep,
				editHide: true
				// template: function(dataItem) {
				// 	return "<a href='/CMSPages/Webins/WI_EC.aspx?idEC=" + dataItem.ItemID + "' target='_blank'>Apri</a>";
				// }
			},

			{
				field: "itemID",
				title: "EC Excel",
				sortable: false,
				groupable: false,
				width: 50,
				//type: "renderfunction",
				//renderFunction: this.renderCellExportExcel,
				cell: "exportExcelCustomCellTemplate",
				editHide: true
			}
		];
	}

	created() {
		if (!(this.isAppMobile == false)) {
			this.pageable["buttonCount"] = 3;
			this.pageable["info"] = false;
			this.pageable["pageSizes"] = undefined;
		}
	}

	mounted() {
		var self = this;
		var p = [
			//api.getDatiDropDown(api.endpoint.DROPDOWN.DISTRIBUTORI).then(res => (self.distributori = res)),
		];

		Promise.all([p])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	renderCellEstrattoContoRep(data: string) {
		//var result = `<a href='/CMSPages/Webins/WI_EC.aspx?idEC=${data}' target='_blank' style='color: #5cb85c;'>Apri</a>`;
		var result =  `<a href='${api.endpoint.REPORT}/reporting/pdf/estrattoContoDistributore/${data}' target='_blank' style='color: #5cb85c;'>Scarica</a>`;

		return result;
	}

	renderCellExportExcel(data: string) {
		//var result = `<button title="Esporta" type="button" class="btn ml-2 btn-success"><svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="file earmark excel fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-file-earmark-excel-fill b-icon bi"><g><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68L8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"></path></g></svg> Esporta </button>`;
		var result = `<a href='#' style='color: #5cb85c;'>Esporta</a>`;

		return result;
	}

	

	exportExcel() {
		this.exportGridExcel(_ENDPONT);
	}

	exportExcelAdesioniEstrattoConto(dataItem) {
		var columns = getTuoiAcquistiColumns(this);
		this.exportGridExcelCustomColumns(_ENDPONT_EXPORT_EXCEL + "/" + dataItem.itemID,null, `Adesioni_Estratto_Conto_${dataItem.mese}_${dataItem.anno}.xlsx`, "",columns );
	}

	

	getData() {
		this.getGridData(_ENDPONT);
	}

	showfilterDialog: boolean = false;

	onApplyFiltersMobile(filtersMobile: Filter) {
		this.filter = filtersMobile;
		this.onFilterMobileApply();
		this.onCloseDialogMessage();
	}
	onRemoveAllFilters() {
		this.clearSortAndFilter();
		//this.onCloseDialogMessage();
	}

	onCloseDialogMessage() {
		this.showfilterDialog = false;
	}

	onOpenFilterDialog() {
		this.showfilterDialog = true;
	}
}
